<template>
  <div :style="cssVars" class="grid">
    <div v-for="(module, index) in row.modules" :key="index" class="grid-item">
      <component
        :is="componentForType(module.type)"
        :value="module"
      />
    </div>
  </div>
</template>

<script>
import { contentFindOption } from '../../plugins/content'
import ContentGeneratorModulesProductBox from './modules/ProductBox.vue'
import ContentGeneratorModulesMedia from './modules/Media.vue'
import CardBox from './modules/CardBox.vue'
import FeatureIconBox from './modules/FeatureIconBox.vue'
export default {
  components: {
    ContentGeneratorModulesProductBox,
    ContentGeneratorModulesMedia,
    CardBox,
    FeatureIconBox
  },
  props: {
    row: { type: Object, default: null }
  },
  computed: {
    cssVars () {
      return {
        '--cols-desktop': `${this.columnsDesktop}`,
        '--cols-mobile': `${this.columnsMobile}`
      }
    },
    columnsMobile () {
      return contentFindOption(this.row?.options, 'columnsMobile').value || 1
    },
    columnsDesktop () {
      return contentFindOption(this.row?.options, 'columnsDesktop').value || 3
    }
  },
  methods: {
    componentForType (type) {
      const map = {
        photo: 'ContentGeneratorModulesMedia',
        cardBox: 'CardBox',
        productBox: 'ContentGeneratorModulesProductBox',
        featureIconBox: 'FeatureIconBox'
      }
      return map[type] || 'ContentGeneratorModulesProductBox'
    }
  }
}
</script>
<style lang="scss" scoped>

.grid {
  margin: 60px 0;
  display: grid;
  grid-template-columns: repeat(var(--cols-desktop), 1fr);
  gap: 20px;
  align-items: start;
  @include touch {
    grid-template-columns: repeat(var(--cols-mobile), 1fr);
  }

  &:has(> .grid-item > .feature-icon-box) {
    @include desktop {
      grid-auto-rows: 1fr;
    }
  }

  .grid-item {
    // background-color: #f0f0f0;
    border-radius: 20px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    height: 100%;
    // :deep(.product-box){
    //   aspect-ratio: 1/1;
    //   .photo-wrapper{
    //     aspect-ratio: 1/1;
    //   }
    // }
    :deep(.card-box){

      flex-grow: 1;

      &:not(.has-bg){
      .text-container{
        @include mobile{
          padding: 16px 0;
        }
      }
      }
    }

    :deep(.feature-icon-box){
      flex-grow: 1;
      display: flex;
      align-items: center;
    }

  }
   .grid-item:has(.box-three){
    height: 100% !important;
    .box-three{
    height: 100%;
    min-height: 80px;
    }

  }

  .grid-slot-empty {
    width: 100%;
    height: 100%;
  }
}
</style>
